/* LUGAZI small things all over the site (24 Oct, Leandro: "kör allt"), each one only where it belongs:
   - every page:   elevator doors slide shut when you click to another page and open on the next one (quick), pages are
                   fetched already when you hover / touch a link, the pixel arrow + the pixel hand as mouse (computer)
   - shop:         the clothes in a frame (queen of spades / skulls), the newest piece gets the red star, the crown on SHOP
   - product:      teeth bite when something goes into the bag
   - start page:   the game - beat your record or reach 150 and the velvet crown lands on the console + it rains money
   - bag:          it rains money when the cash register opens, the ATM keypad to type a discount code,
                   the crying mask when the bag is empty
   - 404:          the door in the field takes you home
   - about:        the suit, the cat as the head, two hands put the crown on it
   Pictures as text in lugazi-plus-<group>-N.js, only the group a page needs is fetched.
   Taking the script line out of lugazi-controls removes all of it. */
(function () {
  if (window.__lgzPlus) return; window.__lgzPlus = 1;
  var me = document.currentScript, V = 'c9469c09', N = {"lift": 2, "shop": 6, "walk": 3, "teeth": 2, "money": 3, "game": 2, "cart": 2, "door": 2, "about": 4, "heart": 2, "gdoor": 6, "lw2": 6, "ransom": 5};
  var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var path = location.pathname.replace(/\/+$/, '') || '/';
  var B = document.body;
  function P() { return window.__lgzPlusP || {}; }
  function has(k) { var M = P(); return M[k] && M[k].n && M[k].filter(Boolean).length === M[k].n; }
  function url(k) { return P()[k].join(''); }
  var asked = {}, ready = {};
  function group(g, done) {
    var n = N[g]; if (!n || !me || !me.src) return;
    if (ready[g]) { try { done(); } catch (e) {} return; }
    if (asked[g]) { asked[g].push(done); return; }
    asked[g] = [done]; var left = n;
    for (var i = 1; i <= n; i++) {
      var s = document.createElement('script');
      s.src = me.src.replace(/lugazi-plus\.js(\?.*)?$/, 'lugazi-plus-' + g + '-' + i + '.js?v=' + V);
      s.onload = function () { if (!--left) { ready[g] = 1; asked[g].forEach(function (f) { try { f(); } catch (e) {} }); } };
      document.head.appendChild(s);
    }
  }
  function css(t) { var s = document.createElement('style'); s.textContent = t; document.head.appendChild(s); }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function img(k, cls) { var i = new Image(); i.alt = ''; i.decoding = 'async'; i.src = url(k); i.className = 'lgz-keep' + (cls ? ' ' + cls : ''); return i; }

  /* =================== elevator doors between pages =================== */
  css('.lgz-lift{position:fixed;inset:0;z-index:2147483600;pointer-events:none;display:flex}' +
    '.lgz-lift i{flex:1;height:100%;background-color:#9a9da1;background-image:linear-gradient(90deg,#7d8186,#c9ccd0 30%,#a3a7ab 55%,#d6d8db 75%,#8e9297);background-size:cover;background-repeat:no-repeat;transition:transform .26s cubic-bezier(.6,0,.4,1);box-shadow:0 0 30px rgba(0,0,0,.45)}' +
    '.lgz-lift i:first-child{background-position:100% 50%;transform:translateX(-101%)}' +
    '.lgz-lift i:last-child{background-position:0 50%;transform:translateX(101%)}' +
    '.lgz-lift.shut i{transform:none}' +
    '.lgz-lift.slow i{transition-duration:.22s}' +
    '.lgz-lift i.gd,.lgz-gate i.gd{background-color:#7b7e82;background-size:auto 100%!important}' +
    '@media (min-width:750px) and (min-aspect-ratio:23/20){.lgz-lift i.gd{background-size:cover!important}}');
  var lift = null;
  function makeLift(shut, plain) {
    if (!plain && (!has('L') || !has('R'))) return null;
    var d = el('div', 'lgz-lift' + (shut ? ' shut' : '')); d.setAttribute('aria-hidden', 'true');
    var l = el('i'), r = el('i'); d.appendChild(l); d.appendChild(r); B.appendChild(d);
    doors(l, r);  /* 24 Oct 21:16: the doors cover the whole screen on computers too when they open (Leandro) */
    return d;
  }
  /* computers (wide screens): his lobby - the painted lift in the old stairwell. Only the two doors move, the wall stays,
     and behind the doors there is the dark lift. Phones keep the doors full screen. */
  /* 24 Oct 20:40: white all around (Leandro) - only the lift with its frame and the floor display above, full height */
  /* 21:16: no concrete - only the floor display above the lift (Leandro) */
  var LB = { W: 538, H: 823, k: 1, door: [40, 117, 496, 813], seam: 267, panel: [227, 22, 321, 48] };
  function isWide() { return innerWidth >= 750 && innerWidth / innerHeight >= 1.15; }
  var lobbyCss = false;
  function geo() {
    var s = innerHeight / LB.H, bw = LB.W * s, bh = innerHeight;
    return { s: s, bw: bw, bh: bh, ox: (innerWidth - bw) / 2, oy: (innerHeight - bh) / 2, k: LB.k };
  }
  function placeFloor(fl) {
    if (!fl || !isWide() || !has('LB')) return;
    var g = geo(), p = LB.panel, k = g.k;
    fl.classList.add('wide');
    fl.style.left = (g.ox + (p[0] + p[2]) / 2 * k * g.s) + 'px'; fl.style.top = (g.oy + (p[1] + p[3]) / 2 * k * g.s) + 'px';
    fl.style.fontSize = Math.max(12, (p[3] - p[1]) * k * g.s * 0.72) + 'px';
  }
  function lobby(d, l, r, fl) {
    if (!isWide()) return;
    if (!has('LB')) { group('lw2', function () { if (d.isConnected) lobby(d, l, r, fl); }); return; }
    if (!lobbyCss && (lobbyCss = true)) css('.lgz-lift.wide,.lgz-gate.wide{display:block;background-repeat:no-repeat}' +
      '.lgz-lift.wide i,.lgz-gate.wide i{position:absolute;flex:none;box-shadow:none!important;background-repeat:no-repeat;margin:0}' +
      '.lgz-lift.wide i{transition:transform .5s cubic-bezier(.6,0,.4,1),clip-path .5s cubic-bezier(.6,0,.4,1)}' +
      '.lgz-lift.wide i:first-child{transform:translateX(-100%);clip-path:inset(0 0 0 100%)}.lgz-lift.wide i:last-child{transform:translateX(100%);clip-path:inset(0 100% 0 0)}' +
      '.lgz-lift.wide.shut i{transform:none;clip-path:inset(0)}' +
      '.lgz-lift.wide{opacity:0;transition:opacity .35s ease .35s}.lgz-lift.wide.shut{opacity:1;transition:opacity .25s}' +
      '.lgz-hole{position:absolute;background:radial-gradient(ellipse at 50% 18%,#6b5a4a 0,#2a221d 45%,#0d0b0a 100%)}' +
      '.lgz-floor.wide{position:fixed!important;transform:translate(-50%,-50%);padding:0 .4em;background:transparent!important;box-shadow:none!important;letter-spacing:.1em;line-height:1}');
    function lay() {
      var g = geo(), k = g.k, D = LB.door;
      d.classList.add('wide'); d.style.backgroundColor = '#fff';
      d.style.backgroundImage = 'url(' + url('LB') + ')'; d.style.backgroundSize = g.bw + 'px ' + g.bh + 'px'; d.style.backgroundPosition = g.ox + 'px ' + g.oy + 'px';
      var top = g.oy + D[1] * k * g.s, h = (D[3] - D[1]) * k * g.s, x0 = g.ox + D[0] * k * g.s, xs = g.ox + LB.seam * k * g.s, x1 = g.ox + D[2] * k * g.s;
      var hole = d.querySelector('.lgz-hole'); if (!hole) { hole = el('div', 'lgz-hole'); d.insertBefore(hole, d.firstChild); }
      hole.style.cssText = 'left:' + x0 + 'px;top:' + top + 'px;width:' + (x1 - x0) + 'px;height:' + h + 'px';
      [[l, x0, xs - x0], [r, xs, x1 - xs]].forEach(function (q) {
        var e = q[0]; e.dataset.wide = '1'; e.classList.remove('gd');
        e.style.left = q[1] + 'px'; e.style.top = top + 'px'; e.style.width = q[2] + 'px'; e.style.height = h + 'px';
        e.style.backgroundImage = 'url(' + url('LB') + ')'; e.style.backgroundSize = g.bw + 'px ' + g.bh + 'px';
        e.style.backgroundPosition = (g.ox - q[1]) + 'px ' + (g.oy - top) + 'px';
      });
      placeFloor(fl || d.querySelector('.lgz-floor'));
    }
    lay();
    var on = function () { if (!d.isConnected) { removeEventListener('resize', on); return; } if (isWide()) lay(); };
    addEventListener('resize', on);
  }
  /* 24 Oct 19:17: his painted door (the pink figure, the hearts, LUGAZI TIGER) is painted across the lift doors -
     each door carries its half, so the painting splits when they open */
  var paintCss = false;
  /* his painted lift (pink figure, hearts, LUGAZI) on the doors; the plain steel photo until it has loaded */
  function doors(l, r) {
    function set(a, b) { if (l.dataset.wide) return; l.style.backgroundImage = 'url(' + url(a) + ')'; r.style.backgroundImage = 'url(' + url(b) + ')'; }
    function painted() { if (has('GL') && has('GR')) {
      /* 21:47: keep his doors in the browser, so the next page can show them from its very first frame (no white flash) */
      try { if (!sessionStorage.getItem('lgz-gl')) { sessionStorage.setItem('lgz-gl', url('GL')); sessionStorage.setItem('lgz-gr', url('GR')); } } catch (e) {}
      if (l.dataset.wide) return true; set('GL', 'GR'); l.classList.add('gd'); r.classList.add('gd'); return true; } }
    if (painted()) return;
    if (has('L') && has('R')) set('L', 'R'); else group('lift', function () { if (!l.classList.contains('gd')) set('L', 'R'); });
    group('gdoor', painted);
  }
  function paint(l, r) {
    if (!paintCss && (paintCss = true)) css('.lgz-lift i,.lgz-gate i{position:relative;overflow:hidden}' +
      '.lgz-paint{position:absolute;top:50%;height:min(100%,calc(100vw * 2.18));width:auto;max-width:none;pointer-events:none;opacity:.94;filter:none!important}' +
      '.lgz-paint.l{left:100%;transform:translate(-50%,-50%)}.lgz-paint.r{left:0;transform:translate(-50%,-50%)}');
    function put() {
      if (!has('gf') || l.querySelector('.lgz-paint')) return;
      [[l, 'l'], [r, 'r']].forEach(function (p) { var im = img('gf', 'lgz-paint ' + p[1]); im.setAttribute('aria-hidden', 'true'); p[0].appendChild(im); });
    }
    if (has('gf')) put(); else group('graf', put);
  }
  function inside(a) {
    if (!a || !a.href || a.target && a.target !== '_self' || a.hasAttribute('download')) return false;
    if (a.dataset && a.dataset.lgzBuy) return false;
    var u; try { u = new URL(a.href, location.href); } catch (e) { return false; }
    if (u.origin !== location.origin || !/^https?:$/.test(u.protocol)) return false;
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return false;
    if (/^\/(cart\/(add|change|update|clear)|account\/logout)/.test(u.pathname)) return false;
    var h = a.getAttribute('href') || ''; if (h.charAt(0) === '#' || /^javascript:/i.test(h)) return false;
    return u;
  }
  var pre = {};
  function prefetch(a) {
    var u = inside(a); if (!u || pre[u.href]) return; pre[u.href] = 1;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = u.href; document.head.appendChild(l);
  }
  document.addEventListener('pointerover', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) prefetch(a); }, { passive: true });
  document.addEventListener('touchstart', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) prefetch(a); }, { passive: true });
  document.addEventListener('click', function (e) {
    if (calm || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]'); var u = inside(a); if (!u) return;
    if (!has('L')) return;
    /* 25 Oct 02:55 (Leandro): the doors only once per visit - after that the pages change right away */
    try { if (sessionStorage.getItem('lgz-rode')) return; sessionStorage.setItem('lgz-rode', '1'); } catch (x) {}
    e.preventDefault();
    if (lift) lift.remove(); lift = makeLift(false); if (!lift) { location.href = u.href; return; }
    void lift.offsetWidth; lift.classList.add('shut');
    try { sessionStorage.setItem('lgz-lift', String(Date.now())); } catch (x) {}
    setTimeout(function () { location.href = u.href; }, 270);
  });
  /* arriving: the doors open */
  function arrive() {
    /* still on the entrance page (the site may reload it once before going in): keep the ride for the next page */
    if (!/[?&]lugazi=/.test(location.search) && (location.pathname === '/' || location.pathname === '') && document.querySelector('a.lw-entrance') && (function () { try { return sessionStorage.getItem('lgz-floor') === '1'; } catch (e) { return false; } })()) return;
    var t = 0; try { t = +sessionStorage.getItem('lgz-lift') || 0; sessionStorage.removeItem('lgz-lift'); } catch (e) {}
    if (!t || Date.now() - t > 6000 || calm) return;
    /* 21:20: wait (max 0.9 s, behind the steel cover) for his painted doors, so the plain steel never flashes first */
    if (!has('GL') || !has('GR')) { var went = false, go = function () { if (went) return; went = true; ride(); }; group('gdoor', go); setTimeout(go, 250); return; }
    ride();
  }
  function ride() {
    var d = makeLift(true, true); d.classList.add('slow');
    document.documentElement.classList.remove('lgz-lifting');
    var fromGate = false; try { fromGate = sessionStorage.getItem('lgz-floor') === '1'; sessionStorage.removeItem('lgz-floor'); } catch (e) {}
    var opened = false, open = function () { if (opened) return; opened = true; setTimeout(function () { d.classList.remove('shut'); setTimeout(function () { d.remove(); }, 360); }, 20); };  /* 25 Oct 02:22: faster (Leandro) */
    if (false && fromGate) {   /* 25 Oct 02:53: no counting any more - the doors just open fast (Leandro) */
      /* coming up from the entrance: the floor counts on, ding, the doors open */
      floorCss();
      var f2 = el('div', 'lgz-floor up'); f2.innerHTML = '<b>&#9650;</b><span>1</span>'; f2.style.position = 'fixed'; f2.style.zIndex = '2147483601'; B.appendChild(f2);
      var n = 1, num = f2.querySelector('span');
      var iv = setInterval(function () {
        n++; num.textContent = n; if (n < 4) return;
        clearInterval(iv); f2.classList.add('lgz-gate-ding');
        var go = function () { open(); f2.style.transition = 'opacity .3s'; f2.style.opacity = '0'; setTimeout(function () { f2.remove(); }, 400); };
        if (has('L')) go(); else { group('lift', go); setTimeout(go, 250); }
      }, 45);
      return;
    }
    if (has('L')) open(); else { group('lift', open); setTimeout(open, 250); }
  }
  arrive();
  addEventListener('pageshow', function (e) { if (e.persisted && lift) { lift.remove(); lift = null; } });

  /* =================== the entrance: closed lift doors, his icon is the call button =================== */
  var fcss = false;
  function floorCss() {
    if (fcss) return; fcss = true;
    css('.lgz-floor{position:absolute;left:50%;top:clamp(12px,2.2svh,24px);transform:translateX(-50%);display:flex;align-items:center;gap:8px;padding:6px 14px;border-radius:6px;background:#0c0c0c;box-shadow:inset 0 0 0 2px #444;font:700 clamp(20px,5vw,28px)/1 ui-monospace,Menlo,monospace;color:#ff3b2f;text-shadow:0 0 8px rgba(255,59,47,.8);letter-spacing:.08em}' +
      '.lgz-floor b{font-size:.6em;opacity:.35;transition:opacity .1s}.lgz-floor.up b{opacity:1}' +
      '.lgz-gate-ding{animation:lgz-ding .5s ease-out}@keyframes lgz-ding{0%{box-shadow:inset 0 0 0 2px #444}40%{box-shadow:inset 0 0 0 2px #ff3b2f,0 0 24px rgba(255,59,47,.7)}100%{box-shadow:inset 0 0 0 2px #444}}' +
      'html.lgz-dark .lgz-floor{filter:none!important}' +
      /* 21:19: on phones the display sits inside the steel band above the doors (Leandro) */
      '@media not all and (min-width:750px) and (min-aspect-ratio:23/20){.lgz-floor:not(.wide){top:calc(100vh * 31 / 1200)!important;top:calc(100svh * 31 / 1200)!important;transform:translate(-50%,-50%)!important;font-size:max(13px,2.2svh)!important;padding:.25em .65em!important;gap:.4em!important;border-radius:4px!important;box-shadow:inset 0 0 0 1px #3a3a3a!important}}');
  }
  /* 24 Oct 20:54: his JOIN THE LIST placed nicely (Leandro) - computer: on the white wall beside the lift;
     phone: in white, like a tag on the doors (21:17) */
  var joinCss = false;
  function join() {
    var E = 'html body[data-lugazi-view=entrance]:not(#lgzx) .lwl-trigger', R = document.documentElement;
    if (!joinCss && (joinCss = true)) css(E + '{position:fixed!important;z-index:30;margin:0!important;right:auto!important;left:50%!important;top:auto!important;bottom:17.5vh!important;bottom:17.5svh!important;translate:none!important;width:min(54vw,215px)!important;height:auto!important;' +
      'transform:translateX(-50%) rotate(-3deg)!important;background:transparent!important;padding:0!important;box-shadow:none!important;opacity:1!important;filter:invert(1) drop-shadow(0 0 1px #000) drop-shadow(0 2px 3px rgba(0,0,0,.8))!important}' +
      E + ' .lwl-trig-art{width:100%!important;height:auto!important;display:block;position:static!important;transform:none!important}' +
      'html.lgz-jw body[data-lugazi-view=entrance]:not(#lgzx) .lwl-trigger{filter:none!important;bottom:auto!important;left:var(--lgz-jx)!important;top:56vh!important;width:var(--lgz-jwd)!important;transform:translateY(-50%) rotate(-4deg)!important}');
    function put() {
      if (isWide()) {
        var g = geo(), x = g.ox + g.bw, free = innerWidth - x, w = Math.max(150, Math.min(280, free - 80));
        R.classList.add('lgz-jw'); R.style.setProperty('--lgz-jx', (x + (free - w) / 2) + 'px'); R.style.setProperty('--lgz-jwd', w + 'px');
      } else R.classList.remove('lgz-jw');
    }
    put(); addEventListener('resize', put);
  }
  /* 24 Oct 21:26: on the entrance the doors open a crack now and then - shy, small and quick - so you see the lift can open (Leandro) */
  var teaseCss = false;
  function tease(d) {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!teaseCss && (teaseCss = true)) css('.lgz-gate i{transition:transform .2s cubic-bezier(.3,0,.3,1),clip-path .2s cubic-bezier(.3,0,.3,1);clip-path:inset(0)}' +
      '.lgz-gate.peek i:first-of-type{transform:translateX(-2.5%);clip-path:inset(0 0 0 2.5%)}.lgz-gate.peek i:last-of-type{transform:translateX(2.5%);clip-path:inset(0 2.5% 0 0)}' +
      '.lgz-gate.peek.big i:first-of-type{transform:translateX(-4.5%);clip-path:inset(0 0 0 4.5%)}.lgz-gate.peek.big i:last-of-type{transform:translateX(4.5%);clip-path:inset(0 4.5% 0 0)}' +
      '.lgz-gate:not(.wide){background:radial-gradient(ellipse at 50% 18%,#6b5a4a 0,#2a221d 45%,#0d0b0a 100%)}');
    var k = 0;
    function peek() {
      if (!d.isConnected) return;
      if (!document.hidden && document.body.getAttribute('data-lugazi-view') === 'entrance' && !document.querySelector('.lgz-lift')) {
        var big = (k++ % 3) === 2; d.classList.toggle('big', big); d.classList.add('peek');
        setTimeout(function () { d.classList.remove('peek'); }, big ? 420 : 300);
      }
      setTimeout(peek, 3200);
    }
    setTimeout(peek, 1400);
  }
  function gate() {
    floorCss();
    var g = document.querySelector('a.lw-entrance'); if (!g || g.querySelector('.lgz-gate')) return;
    css('a.lw-entrance{isolation:isolate}' +
      '.lgz-gate{position:fixed;inset:0;z-index:-1;display:flex;pointer-events:none;background:#2b2d30}' +
      '.lgz-gate i{flex:1;margin:0;background-size:cover;background-repeat:no-repeat;box-shadow:inset 0 0 18px rgba(0,0,0,.35)}' +
      '.lgz-gate i:first-of-type{background-position:100% 50%;box-shadow:inset -2px 0 0 rgba(0,0,0,.55),inset 0 0 18px rgba(0,0,0,.35)}.lgz-gate i:last-of-type{background-position:0 50%}' +
      '.lgz-gate .lgz-floor{z-index:2}' +
      'html.lgz-dark .lgz-gate{filter:none!important}' +
      'html body a.lw-entrance > img{opacity:0!important;animation:none!important}html body .lgz-tap{display:none!important}' +
      'a.lw-entrance{cursor:pointer}' +
      'html body[data-lugazi-view=entrance] .lc-cat{display:none!important}' +
      'html.lgz-going{opacity:1!important;transition:none!important}');  /* 24 Oct 19:50: no cat walking on the lift (Leandro) */
    var d = el('div', 'lgz-gate'); d.setAttribute('aria-hidden', 'true');
    var l = el('i'), r = el('i'); doors(l, r);
    var fl = el('div', 'lgz-floor'); fl.innerHTML = '<b>&#9650;</b><span>1</span>';
    d.appendChild(l); d.appendChild(r); d.appendChild(fl); g.insertBefore(d, g.firstChild);
    lobby(d, l, r, fl);
    join();
    prefetch(g);  /* the start page is fetched while you look at the lift, so it opens fast */
    tease(d);
    /* tap: the doors close over everything, then the site goes on to the start page as always - where they open again */
    addEventListener('click', function (e) {
      if (!g.isConnected || g.hidden || document.body.getAttribute('data-lugazi-view') !== 'entrance') return;
      if (!(g.contains(e.target) || (e.target.closest && e.target.closest('.lc-cat'))) || (e.target.closest && e.target.closest('.lwl-trigger'))) return;
      try { sessionStorage.setItem('lgz-lift', String(Date.now())); sessionStorage.setItem('lgz-floor', '1'); sessionStorage.setItem('lgz-rode', '1'); } catch (x) {}
      if (calm || document.querySelector('.lgz-lift')) return;
      document.documentElement.classList.add('lgz-going');  /* 21:47: the entrance used to fade the whole page to white before leaving - the doors cover it instead */
      var lf = makeLift(false, true); lf.style.zIndex = '2147483600'; lf.classList.add('shut');
      /* 25 Oct 02:45: go at once (Leandro: faster) - the doors are already shut on the entrance */
      try { var u = new URL(g.href, location.href), pv = new URLSearchParams(location.search).get('preview_theme_id'); if (pv && !u.searchParams.has('preview_theme_id')) u.searchParams.set('preview_theme_id', pv); location.assign(u.href); } catch (x) {}
    }, true);
  }

  /* =================== pixel mouse (computer only) =================== */
  function cursors() {
    if (!fine || !has('ph') || !has('pa')) return;
    css('html body:not(#lgzx),html body:not(#lgzx) *{cursor:url(' + url('pa') + ') 1 1,auto!important}' +
      'html body:not(#lgzx) a,html body:not(#lgzx) a *,html body:not(#lgzx) button,html body:not(#lgzx) button *,html body:not(#lgzx) [role=button],html body:not(#lgzx) label,html body:not(#lgzx) summary,html body:not(#lgzx) select,html body:not(#lgzx) .lgz-tv-scr,html body:not(#lgzx) .lgz-tv-scr *{cursor:url(' + url('ph') + ') 9 1,pointer!important}' +
      'html body:not(#lgzx) input[type=text],html body:not(#lgzx) input[type=email],html body:not(#lgzx) input[type=search],html body:not(#lgzx) textarea{cursor:text!important}');
  }
  if (isWide()) group('lw2', function () {}); group('gdoor', function () {});
  group('lift', function () { cursors(); gate(); });  /* 24 Oct 16:26: no ladybug (Leandro) */

  /* =================== the ladybug: now and then she crawls across the screen; touch her and she flies off =================== */
  function bug() {
    if (calm || !has('bug')) return;
    css('.lgz-bug{position:fixed;left:0;top:0;width:34px;height:auto;z-index:2147483300;cursor:pointer;filter:none!important;will-change:transform;-webkit-tap-highlight-color:transparent}');
    function go() {
      if (document.hidden) { setTimeout(go, 5000); return; }
      var W = innerWidth, H = innerHeight, side = Math.random() < .5, b = img('bug', 'lgz-bug'); b.setAttribute('aria-hidden', 'true');
      var x0 = side ? -40 : W + 40, x1 = side ? W + 40 : -40, y0 = H * (.25 + Math.random() * .6), y1 = H * (.2 + Math.random() * .6);
      var cx = W / 2 + (Math.random() - .5) * W * .4, cy = (y0 + y1) / 2 + (Math.random() - .5) * H * .5;
      var t0 = performance.now(), dur = 11000 + Math.random() * 6000, gone = false, px = x0, py = y0;
      B.appendChild(b);
      function step(now) {
        if (gone) return;
        var t = Math.min(1, (now - t0) / dur), u = 1 - t;
        var x = u * u * x0 + 2 * u * t * cx + t * t * x1, y = u * u * y0 + 2 * u * t * cy + t * t * y1 + Math.sin(now / 90) * 1.2;
        var ang = Math.atan2(y - py, x - px) * 180 / Math.PI + 90; px = x; py = y;
        b.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + ang.toFixed(0) + 'deg)';
        if (t < 1) requestAnimationFrame(step); else { b.remove(); setTimeout(go, 40000 + Math.random() * 40000); }
      }
      requestAnimationFrame(step);
      function fly() {
        if (gone) return; gone = true;
        var a = b.animate([{ transform: b.style.transform }, { transform: b.style.transform + ' translate(0,-' + (H * .8) + 'px) scale(2.2) rotate(40deg)', opacity: 0 }], { duration: 900, easing: 'cubic-bezier(.3,.1,.6,1)', fill: 'forwards' });
        a.onfinish = function () { b.remove(); setTimeout(go, 50000 + Math.random() * 40000); };
      }
      b.addEventListener('pointerenter', fly); b.addEventListener('pointerdown', fly);
    }
    setTimeout(go, 9000 + Math.random() * 12000);
  }

  /* =================== waiting list: the heart beats when you join =================== */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelector || !f.querySelector('input[type=email], .lwl-email')) return;
    var em = f.querySelector('input[type=email], .lwl-email'); if (!em || !/.+@.+\..+/.test(em.value || '')) return;
    group('heart', function () {
      if (!has('heart') || calm) return;
      var h = img('heart'); h.setAttribute('aria-hidden', 'true');
      h.style.cssText = 'position:fixed;left:50%;top:50%;width:min(46vw,220px);height:auto;z-index:2147483400;pointer-events:none;filter:none!important;transform:translate(-50%,-50%)';
      B.appendChild(h);
      var a = h.animate([
        { transform: 'translate(-50%,-50%) scale(.2)', opacity: 0 }, { transform: 'translate(-50%,-50%) scale(1)', opacity: 1, offset: .15 },
        { transform: 'translate(-50%,-50%) scale(1.18)', offset: .25 }, { transform: 'translate(-50%,-50%) scale(1)', offset: .33 },
        { transform: 'translate(-50%,-50%) scale(1.18)', offset: .43 }, { transform: 'translate(-50%,-50%) scale(1)', offset: .51 },
        { transform: 'translate(-50%,-50%) scale(1.18)', offset: .61 }, { transform: 'translate(-50%,-50%) scale(1)', opacity: 1, offset: .75 },
        { transform: 'translate(-50%,-50%) scale(.3)', opacity: 0 }], { duration: 2600, easing: 'ease-in-out', fill: 'forwards' });
      a.onfinish = function () { h.remove(); };
    });
  }, true);

  /* =================== money rain =================== */
  function rain(n) {
    if (calm) return;
    group('money', function () {
      var ks = ['b0', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7'].filter(has); if (!ks.length) return;
      var box = el('div'); box.setAttribute('aria-hidden', 'true');
      box.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:2147483500;overflow:hidden';
      B.appendChild(box);
      var W = innerWidth, H = innerHeight, last = 0;
      for (var i = 0; i < (n || 22); i++) {
        var b = img(ks[i % ks.length]); var w = 46 + Math.random() * 40;
        b.style.cssText = 'position:absolute;top:-140px;left:' + (Math.random() * (W - 30)) + 'px;width:' + w + 'px;height:auto;filter:none!important';
        box.appendChild(b);
        var dur = 1500 + Math.random() * 1300, dl = Math.random() * 700, sw = (Math.random() * 80 - 40), r0 = Math.random() * 360;
        last = Math.max(last, dur + dl);
        b.animate([
          { transform: 'translate(0,0) rotate(' + r0 + 'deg) rotateX(0deg)' },
          { transform: 'translate(' + sw + 'px,' + (H * 0.5) + 'px) rotate(' + (r0 + 160) + 'deg) rotateX(180deg)', offset: 0.5 },
          { transform: 'translate(' + (-sw) + 'px,' + (H + 220) + 'px) rotate(' + (r0 + 330) + 'deg) rotateX(360deg)' }
        ], { duration: dur, delay: dl, easing: 'cubic-bezier(.3,.1,.6,1)', fill: 'both' });
      }
      setTimeout(function () { box.remove(); }, last + 200);
    });
  }
  window.lgzRain = rain;

  /* =================== start page: the game =================== */
  function crownOn() {
    var g = document.querySelector('.lgz-game-box'); if (!g) return;
    group('game', function () {
      if (!has('cv') || g.querySelector('.lgz-crown')) return;
      var c = img('cv', 'lgz-crown'); c.setAttribute('aria-hidden', 'true');
      c.style.cssText = 'position:absolute;left:50%;top:-6%;width:30%;height:auto;z-index:20;pointer-events:none;filter:none!important;transform:translate(-50%,-70%)';
      if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
      g.appendChild(c);
      c.animate([{ transform: 'translate(-50%,-420%) rotate(-25deg)', opacity: 0 }, { transform: 'translate(-50%,-70%) rotate(6deg)', opacity: 1, offset: .6 },
        { transform: 'translate(-50%,-85%) rotate(-4deg)', offset: .8 }, { transform: 'translate(-50%,-70%) rotate(0deg)', opacity: 1 }],
        { duration: calm ? 1 : 900, easing: 'cubic-bezier(.3,.7,.3,1)', fill: 'both' });
      setTimeout(function () { var a = c.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 600, fill: 'both' }); a.onfinish = function () { c.remove(); }; }, 6500);
    });
  }
  if (path === '/' || document.querySelector('.lgz-game, .lw-book, .lw-world')) {
    try {
      var SI = Storage.prototype.setItem;
      Storage.prototype.setItem = function (k, v) {
        var old = null; try { old = this.getItem(k); } catch (e) {}
        SI.apply(this, arguments);
        try {
          if (k === 'lgz-game-best' && +old > 0 && +v > +old) { crownOn(); rain(26); }
          else if (k === 'lgz-game-won' && v === '1' && old !== '1') { crownOn(); rain(30); }
        } catch (e) {}
      };
    } catch (e) {}
    setTimeout(function () { group('game', function () {}); group('money', function () {}); }, 6000);
  }

  /* =================== product page: the teeth bite =================== */
  function chomp() {
    if (calm) return;
    group('teeth', function () {
      if (!has('tt') || !has('tb')) return;
      var w = Math.min(innerWidth * 0.82, 460);
      var box = el('div'); box.setAttribute('aria-hidden', 'true');
      box.style.cssText = 'position:fixed;left:50%;top:50%;width:' + w + 'px;height:' + (w * 0.95) + 'px;transform:translate(-50%,-50%);pointer-events:none;z-index:2147483400';
      var t = img('tt'), b = img('tb');
      t.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:auto;filter:none!important';
      b.style.cssText = 'position:absolute;left:0;bottom:0;width:100%;height:auto;filter:none!important';
      box.appendChild(t); box.appendChild(b); B.appendChild(box);
      var o = { duration: 1000, easing: 'cubic-bezier(.4,0,.3,1)', fill: 'both' };
      t.animate([{ transform: 'translateY(-160%)' }, { transform: 'translateY(-18%)', offset: .25 }, { transform: 'translateY(30%)', offset: .38 }, { transform: 'translateY(-10%)', offset: .5 }, { transform: 'translateY(30%)', offset: .62 }, { transform: 'translateY(-18%)', offset: .78 }, { transform: 'translateY(-160%)' }], o);
      var a = b.animate([{ transform: 'translateY(160%)' }, { transform: 'translateY(18%)', offset: .25 }, { transform: 'translateY(-26%)', offset: .38 }, { transform: 'translateY(10%)', offset: .5 }, { transform: 'translateY(-26%)', offset: .62 }, { transform: 'translateY(18%)', offset: .78 }, { transform: 'translateY(160%)' }], o);
      a.onfinish = function () { box.remove(); };
    });
  }
  window.lgzChomp = chomp;
  if (/^\/products\//.test(path) || /\/collections\/.+\/products\//.test(path)) {
    var F = window.fetch;
    if (F) window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = F.apply(this, arguments);
      if (/\/cart\/add/.test(u)) p.then(function (r) { if (r && r.ok) chomp(); }, function () {});
      return p;
    };
    setTimeout(function () { group('teeth', function () {}); }, 2500);
  }

  /* =================== shop: frames, the star, the crown =================== */
  function shop() {
    var cards = [].slice.call(document.querySelectorAll('a.lzs-card--wear')); if (!cards.length) return;
    group('shop', function () {
      css('.lgz-fr{position:absolute;pointer-events:none;z-index:4;box-sizing:border-box}' +
        '.lgz-fr--card{inset:-3% -2%;border-style:solid;border-width:clamp(26px,7vw,40px) clamp(12px,3.2vw,18px);border-image:url(' + url('card') + ') 138 63 round;filter:none!important}' +
        '.lgz-fr--skulls{inset:-3% -2%;border-style:solid;border-width:clamp(15px,4vw,24px);border-image:url(' + url('skulls') + ') 57 round;filter:none!important}' +
        '.lzs-card--wear .lzs-media{position:relative;display:block;overflow:visible!important}.lzs-card--wear{overflow:visible!important}.lzs-item{overflow:visible!important}' +
        '.lgz-star{position:absolute;right:-6%;top:-6%;width:28%;height:auto;z-index:6;pointer-events:none;filter:none!important;transform:rotate(14deg);animation:lgz-star 2.6s ease-in-out infinite}' +
        '@keyframes lgz-star{0%,100%{transform:rotate(14deg) scale(1)}50%{transform:rotate(4deg) scale(1.08)}}' +
        '.lzs-title{display:flex!important;flex-direction:column;align-items:center}.lgz-shopcrown{display:block;width:min(24vw,110px);height:auto;margin:0 auto -10px;filter:none!important;transform:rotate(-6deg);animation:lgz-cr 3.4s ease-in-out infinite}' +
        '@keyframes lgz-cr{0%,100%{transform:rotate(-6deg) translateY(0)}50%{transform:rotate(-2deg) translateY(-5px)}}' +
        '@media(prefers-reduced-motion:reduce){.lgz-star,.lgz-shopcrown{animation:none}}');
      cards.forEach(function (c, i) {
        var m = c.querySelector('.lzs-media'); if (!m || m.querySelector('.lgz-fr')) return;
        /* 24 Oct 15:21: no frames around the clothes (Leandro) */
      });
      /* the crown sits on the SHOP word */
      /* 24 Oct 15:21: no crown on SHOP (Leandro) */
      /* the newest piece gets the star */
      Promise.all(cards.map(function (c) {
        var h = (c.getAttribute('href') || '').split('/products/')[1]; if (!h) return Promise.resolve(0);
        return fetch('/products/' + h.split('?')[0] + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { return p ? Date.parse(p.published_at || p.created_at) || 0 : 0; }, function () { return 0; });
      })).then(function (ts) {
        return;  /* 24 Oct 19:12: no red star (Leandro) */
        var best = Math.max.apply(null, ts); if (!best) return; var i = ts.indexOf(best);
        var m = cards[i].querySelector('.lzs-media'); if (m && !m.querySelector('.lgz-star')) { var s = img('star', 'lgz-star'); s.setAttribute('aria-hidden', 'true'); m.appendChild(s); }
      });
    });
  }
  /* people walking by along the bottom of the shop, like a street */
  function street() {
    var grid = document.querySelector('.lzs'); if (!grid || document.querySelector('.lgz-street')) return;
    group('walk', function () {
      var ks = []; for (var i = 0; i < 13; i++) if (has('w' + i)) ks.push('w' + i); if (!ks.length) return;
      css('.lgz-street{position:relative;height:clamp(110px,22vw,170px);margin:30px 0 0;overflow:hidden;pointer-events:none}' +
        '.lgz-street img{position:absolute;bottom:4px;height:clamp(70px,14vw,120px);width:auto;filter:none!important}');
      var st = el('div', 'lgz-street'); st.setAttribute('aria-hidden', 'true'); grid.appendChild(st);
      if (calm) { ks.slice(0, 5).forEach(function (k, i) { var p = img(k); p.style.left = (8 + i * 19) + '%'; st.appendChild(p); }); return; }
      ks.forEach(function (k, i) {
        var p = img(k); st.appendChild(p);
        var dir = i % 2 ? 1 : -1, dur = 26000 + Math.random() * 22000, sc = .75 + Math.random() * .35;
        p.style.height = 'calc(clamp(70px,14vw,120px) * ' + sc.toFixed(2) + ')'; p.style.zIndex = String(Math.round(sc * 10));
        p.animate([{ transform: 'translateX(' + (dir > 0 ? '-20vw' : '110vw') + ')' }, { transform: 'translateX(' + (dir > 0 ? '110vw' : '-20vw') + ')' }],
          { duration: dur, delay: -Math.random() * dur, iterations: Infinity });
        p.animate([{ translate: '0 0' }, { translate: '0 -3px' }, { translate: '0 0' }], { duration: 520 + Math.random() * 200, iterations: Infinity });
      });
    });
  }
  if (/^\/collections/.test(path) || B.classList.contains('lugazi-collection')) {
    /* 24 Oct: no people walking along the shop (Leandro) */
    if (document.readyState === 'complete') shop(); else addEventListener('load', shop);
    setTimeout(shop, 2500);
  }

  /* =================== the bag =================== */
  if (path === '/cart') {
    /* the register opens: money rains */
    var wasOpen = false;
    new MutationObserver(function () {
      var k = document.querySelector('.lgz-kassa'); var o = !!(k && k.classList.contains('is-open'));
      if (o && !wasOpen) rain(18); wasOpen = o;
    }).observe(B, { subtree: true, attributes: true, attributeFilter: ['class'] });
    group('cart', function () { setTimeout(bag, 400); });
  }
  function bag() {
    css('.lgz-mask{display:block;width:min(40vw,170px);height:auto;margin:10px auto 30px;filter:none!important;transform-origin:50% 8%;animation:lgz-sob 3.2s ease-in-out infinite}' +
      '@keyframes lgz-sob{0%,100%{transform:rotate(-5deg)}50%{transform:rotate(5deg) translateY(3px)}}' +
      '.lgz-maskbox{position:relative;width:max-content;margin:0 auto}' +
      '.lgz-tear{position:absolute;width:7px;height:11px;border-radius:50% 50% 50% 50%/60% 60% 40% 40%;background:linear-gradient(#ffe7a0,#c9971f);opacity:0;animation:lgz-tear 2.4s ease-in infinite}' +
      '@keyframes lgz-tear{0%{opacity:0;transform:translateY(0)}15%{opacity:1}100%{opacity:0;transform:translateY(90px)}}' +
      '@media(prefers-reduced-motion:reduce){.lgz-mask,.lgz-tear{animation:none}}' +
      /* the keypad */
      '.lgz-atm{width:min(100%,300px);margin:14px auto 18px;user-select:none;-webkit-user-select:none}' +
      '.lgz-atm-lcd{display:flex;align-items:center;justify-content:space-between;gap:8px;height:42px;margin:0 0 8px;padding:0 12px;border-radius:6px;background:#9fbf8a;box-shadow:inset 0 2px 6px rgba(0,0,0,.45);font:700 17px/1 ui-monospace,Menlo,monospace;letter-spacing:.12em;color:#1d2a16;cursor:text;overflow:hidden;white-space:nowrap}' +
      '.lgz-atm-lcd b{overflow:hidden;text-overflow:clip}' +
      '.lgz-atm-lcd i{width:9px;height:18px;background:#1d2a16;animation:lgz-blink 1s steps(2,jump-none) infinite;flex:none}' +
      '@keyframes lgz-blink{0%{opacity:1}100%{opacity:0}}' +
      '.lgz-atm-pad{position:relative;line-height:0;border-radius:8px;overflow:hidden}' +
      '.lgz-atm-pad img{width:100%;height:auto;filter:none!important}' +
      '.lgz-atm-pad button{position:absolute;padding:0;margin:0;border:0;background:transparent;border-radius:8%;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background .08s}' +
      '.lgz-atm-pad button:active,.lgz-atm-pad button.dn{background:rgba(0,0,0,.22)}' +
      '.lgz-atm-in{position:absolute;opacity:0;pointer-events:none;width:1px;height:1px}');
    /* empty bag: the crying mask */
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { if (c.item_count > 0) return; sad();  /* 24 Oct: no neon arrow at Checkout (Leandro) */ }, function () {});
  }
  function sad() {
    if (has('mask') && !document.querySelector('.lgz-mask')) {
      var bx = el('div', 'lgz-maskbox'); bx.setAttribute('aria-hidden', 'true');
      bx.appendChild(img('mask', 'lgz-mask'));
      [[38, 44, 0], [62, 44, 1.2]].forEach(function (p) { var t = el('i', 'lgz-tear'); t.style.left = p[0] + '%'; t.style.top = p[1] + '%'; t.style.animationDelay = p[2] + 's'; bx.appendChild(t); });
      var cb = document.querySelector('.lx-cart-btn'), wrap = cb && cb.closest('.cart-title, .section') || document.querySelector('main');
      if (wrap && wrap.offsetHeight) wrap.appendChild(bx); else B.appendChild(bx);
    }
  }
  /* the neon arrow points at Checkout (24 Oct: the ATM keypad is gone - Leandro found it messy) */
  function neon() {
    if (!has('arrow') || document.querySelector('.lgz-neon')) return;
    var btn = document.querySelector('[name="checkout"], .cart__checkout-button, #checkout, button[form*="cart"][type=submit]');
    if (!btn) return;
    css('.lgz-neon{position:absolute;right:-4px;top:-62px;width:min(30vw,120px);height:auto;z-index:5;pointer-events:none;filter:none!important;transform:rotate(-38deg);animation:lgz-neon 1.1s steps(2,jump-none) infinite,lgz-poke 1.6s ease-in-out infinite}' +
      '@keyframes lgz-neon{0%{filter:brightness(1) saturate(1)}100%{filter:brightness(1.25) saturate(1.3) drop-shadow(0 0 6px rgba(255,190,60,.8))}}' +
      '@keyframes lgz-poke{0%,100%{translate:0 0}50%{translate:-6px 6px}}' +
      '@media(prefers-reduced-motion:reduce){.lgz-neon{animation:none}}');
    var host = btn.parentElement; if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var a = img('arrow', 'lgz-neon'); a.setAttribute('aria-hidden', 'true'); host.appendChild(a);
  }
  function atm() {
    if (!has('keypad') || document.querySelector('.lgz-atm')) return;
    var k = document.querySelector('.lgz-kassa'), chk = document.querySelector('[name="checkout"], .cart__checkout-button, button[type=submit][form*=cart], a[href*="checkout"]');
    var anchor = k || chk; if (!anchor) return;
    var box = el('div', 'lgz-atm'); box.setAttribute('aria-label', 'Discount code');
    box.innerHTML = '<div class="lgz-atm-lcd" role="textbox" aria-label="Discount code"><b></b><i></i></div><div class="lgz-atm-pad"></div><input class="lgz-atm-in" type="text" autocapitalize="characters" autocomplete="off" spellcheck="false" aria-label="Discount code" enterkeyhint="go">';
    var pad = box.querySelector('.lgz-atm-pad'), lcd = box.querySelector('.lgz-atm-lcd b'), inp = box.querySelector('.lgz-atm-in');
    pad.appendChild(img('keypad'));
    var code = '', msg = '', lastKey = null, lastAt = 0, tapN = 0;
    var T9 = { '1': 'QZ1', '2': 'ABC2', '3': 'DEF3', '4': 'GHI4', '5': 'JKL5', '6': 'MNO6', '7': 'PRS7', '8': 'TUV8', '9': 'WXY9', '0': '0', '-': '-' };
    function show() { lcd.textContent = msg || code || ''; }
    /* the keys in the photo (percent of the picture) */
    var K = [['1', 6, 5, 16, 19], ['2', 24, 5, 16, 19], ['3', 42, 5, 16, 19], ['enter', 73, 5, 21, 19],
      ['4', 6, 29, 16, 19], ['5', 24, 29, 16, 19], ['6', 42, 29, 16, 19], ['clear', 73, 29, 21, 19],
      ['7', 6, 53, 16, 19], ['8', 24, 53, 16, 19], ['9', 42, 53, 16, 19], ['cancel', 73, 53, 21, 19],
      ['-', 6, 77, 16, 19], ['0', 24, 77, 16, 19], ['', 42, 77, 16, 19], ['+', 73, 77, 21, 19]];
    K.forEach(function (q) {
      if (!q[0]) return;
      var b = el('button'); b.type = 'button'; b.setAttribute('aria-label', q[0]);
      b.style.cssText = 'left:' + q[1] + '%;top:' + q[2] + '%;width:' + q[3] + '%;height:' + q[4] + '%';
      b.addEventListener('click', function () { press(q[0]); });
      pad.appendChild(b);
    });
    function beep(f) {
      try { var A = window.__lgzAC || (window.__lgzAC = new (window.AudioContext || window.webkitAudioContext)()); var o = A.createOscillator(), g = A.createGain(); o.type = 'square'; o.frequency.value = f || 1100; g.gain.setValueAtTime(0.05, A.currentTime); g.gain.exponentialRampToValueAtTime(0.0001, A.currentTime + 0.08); o.connect(g); g.connect(A.destination); o.start(); o.stop(A.currentTime + 0.09); } catch (e) {}
    }
    function press(key) {
      msg = '';
      if (key === 'enter') return go();
      if (key === 'clear') { code = code.slice(0, -1); lastKey = null; beep(700); return show(); }
      if (key === 'cancel') { code = ''; lastKey = null; beep(500); return show(); }
      if (key === '+') { lastKey = null; return show(); }
      beep();
      var set = T9[key] || key, now = Date.now();
      if (key === lastKey && now - lastAt < 900 && set.length > 1) { tapN = (tapN + 1) % set.length; code = code.slice(0, -1) + set[tapN]; }
      else { tapN = 0; if (code.length < 24) code += set[0]; }
      lastKey = key; lastAt = now; show();
    }
    function go() {
      if (!code) return;
      beep(1500);
      try { sessionStorage.setItem('lgz-pin', code); } catch (e) {}
      location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    }
    box.querySelector('.lgz-atm-lcd').addEventListener('click', function () { inp.value = code; inp.focus(); });
    inp.addEventListener('input', function () { code = inp.value.toUpperCase().replace(/[^A-Z0-9\-_]/g, '').slice(0, 24); msg = ''; show(); });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    if (k) k.parentNode.insertBefore(box, k.nextSibling); else anchor.parentNode.insertBefore(box, anchor);
    /* back from /discount: did it work? */
    var pin = null; try { pin = sessionStorage.getItem('lgz-pin'); sessionStorage.removeItem('lgz-pin'); } catch (e) {}
    if (pin) {
      code = pin; show();
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var d = (c.discount_codes || []).filter(function (x) { return (x.code || '').toUpperCase() === pin.toUpperCase(); })[0];
        msg = d && d.applicable ? 'OK  ✓' : 'NOPE'; show(); if (d && d.applicable) rain(16);
        setTimeout(function () { msg = ''; show(); }, 2600);
      }, function () {});
    }
  }

  /* =================== 404: the door =================== */
  if (B.classList.contains('lugazi-404') || /404/.test(document.title)) {
    group('door', function () {
      var main = document.querySelector('main'); if (!main || !has('door') || main.querySelector('.lgz-door')) return;
      css('.lgz-door{position:relative;width:min(88vw,400px);margin:20px auto 10px;line-height:0;border-radius:6px;overflow:hidden}' +
        '.lgz-door img{width:100%;height:auto;filter:none!important;transition:transform .9s cubic-bezier(.6,0,.3,1);transform-origin:61% 50%}' +
        '.lgz-door a{position:absolute;left:46%;top:38%;width:31%;height:25%;border-radius:2px}' +
        '.lgz-door.go img{transform:scale(6)}' +
        '.lgz-door a:focus-visible{outline:2px dashed #fff}');
      var d = el('div', 'lgz-door'); d.appendChild(img('door'));
      var a = el('a'); a.href = '/'; a.setAttribute('aria-label', 'Home'); d.appendChild(a);
      a.addEventListener('click', function (e) { if (calm) return; e.preventDefault(); e.stopPropagation(); d.classList.add('go'); setTimeout(function () { location.href = '/'; }, 850); }, true);
      main.insertBefore(d, main.firstChild);
    });
  }

  /* =================== about: the suit =================== */
  if (/^\/pages\/about/.test(path)) {
    group('about', function aboutUp() {
      var main = [].filter.call(document.querySelectorAll('.lx-aboutpage, main'), function (x) { return x.offsetHeight > 0; })[0];
      if (!main) { if ((window.__lgzAboutTry = (window.__lgzAboutTry || 0) + 1) < 12) setTimeout(aboutUp, 500); return; }
      if (!has('suit') || document.querySelector('.lgz-suit')) return;
      css('.lgz-suit{position:relative;width:min(72vw,300px);aspect-ratio:1/1.05;margin:40px auto 70px}' +
        '.lgz-suit>img{position:absolute}' +
        '.lgz-suit .s-body{left:0;bottom:0;width:100%;height:auto;z-index:3;filter:none!important}' +
        '.lgz-suit .s-crown{left:12%;bottom:44%;width:76%;height:auto;z-index:1;filter:none!important;animation:lgz-crowning 4s ease-in-out infinite}' +
        '@keyframes lgz-crowning{0%,100%{transform:translateY(-12%)}45%,62%{transform:translateY(0)}}' +
        '.lgz-eyes{display:block;width:min(56vw,230px);height:auto;margin:36px auto 0;filter:none!important;animation:lgz-float 5s ease-in-out infinite}' +
        '@keyframes lgz-float{0%,100%{transform:translateY(0) rotate(-2deg)}50%{transform:translateY(-8px) rotate(2deg)}}' +
        '@media(prefers-reduced-motion:reduce){.lgz-suit .s-crown,.lgz-eyes{animation:none}}');
      var s = el('div', 'lgz-suit'); s.setAttribute('aria-hidden', 'true');
      /* 24 Oct: no cat on the suit (Leandro) - the crown is held over the empty collar */
      s.appendChild(img('suit', 's-body'));
      if (has('hc')) s.appendChild(img('hc', 's-crown'));
      if (has('he')) { var he = img('he', 'lgz-eyes'); he.setAttribute('aria-hidden', 'true'); if (main.classList.contains('lx-aboutpage')) main.parentNode.insertBefore(he, main.nextSibling); else main.appendChild(he); }
      if (main.classList.contains('lx-aboutpage')) main.parentNode.insertBefore(s, main.nextSibling); else main.appendChild(s);
      /* 24 Oct 22:30: the LUGAZI ransom-note letters moved here from the end of the start page (Leandro) - under his text, above the suit */
      group('ransom', function () {
        if (document.querySelector('.lgz-ransom') || !['L', 'U', 'G', 'A', 'Z', 'I'].every(has)) return;
        css('.lgz-ransom{display:flex;align-items:flex-end;justify-content:center;gap:clamp(2px,1vw,10px);margin:clamp(30px,6svh,60px) auto 0;height:clamp(64px,17vw,130px);cursor:default}' +
          '.lgz-ransom img{height:100%;width:auto;filter:none!important;transform:rotate(var(--r)) translateY(var(--y));transition:transform .35s cubic-bezier(.2,.9,.25,1.6);-webkit-user-drag:none}' +
          '.lgz-ransom img.bop{transform:rotate(calc(var(--r) * -2)) translateY(-14%) scale(1.08)}' +
          '.lgz-ransom img[data-l=I]{height:96%}.lgz-ransom img[data-l=Z]{height:74%}.lgz-ransom img[data-l=U],.lgz-ransom img[data-l=G]{height:90%}' +
          '@media(prefers-reduced-motion:reduce){.lgz-ransom img{transition:none}}');
        var row = el('div', 'lgz-ransom lgz-keep'); row.setAttribute('role', 'img'); row.setAttribute('aria-label', 'LUGAZI');
        var R = { L: -5, U: 4, G: -3, A: 6, Z: -7, I: 3 }, Y = { L: '0%', U: '-6%', G: '4%', A: '-3%', Z: '-14%', I: '2%' };
        function bop(im) { im.classList.add('bop'); clearTimeout(im._t); im._t = setTimeout(function () { im.classList.remove('bop'); }, 380); }
        ['L', 'U', 'G', 'A', 'Z', 'I'].forEach(function (k) {
          var im = img(k); im.dataset.l = k; im.style.setProperty('--r', R[k] + 'deg'); im.style.setProperty('--y', Y[k]);
          im.addEventListener('pointerenter', function () { bop(im); }); im.addEventListener('pointerdown', function () { bop(im); });
          row.appendChild(im);
        });
        if (main.classList.contains('lx-aboutpage')) main.parentNode.insertBefore(row, main.nextSibling); else main.appendChild(row);
        if (!calm) setInterval(function () { if (document.hidden) return; var r = row.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; bop(row.children[Math.random() * 6 | 0]); }, 1900);
      });
    });
  }
})();
